// extracted by mini-css-extract-plugin
export var actionButton = "_cr-0";
export var attachmentLine = "_cr-1";
export var fileInput = "_cr-2";
export var fileUploadWrapper = "_cr-4";
export var footer = "_cr-3";
export var modalContent = "_cr-5";
export var paperclip = "_cr-6";
export var quillEditor = "_cr-7";